<template>
  <template v-if="createLink">
    <NuxtLink :to="brand?.brandWorldUrl" class="brand" external>
      <ArticleExpMedium
        v-if="brand?.logo && typeof brand?.logo == 'string' && props?.showLogo"
        :class="imgClass"
        :medium-id="brand?.logo"
        :preset="logoPreset"
      />
      <NuxtImg
        v-else-if="brand?.logo && typeof brand?.logo == 'object' && props?.showLogo"
        densities="x1"
        :class="imgClass"
        provider="cloudflare"
        :src="'/' + brand?.logo?.originalData"
        :alt="brand?.logo?.name"
        :preset="logoPreset"
      />
      <template v-if="brand?.name && !props?.showLogo">{{ brand?.name }}</template>
    </NuxtLink>
  </template>
  <template v-else>
    <div class="brand">
      <ArticleExpMedium
        v-if="brand?.logo && typeof brand?.logo == 'string' && props?.showLogo"
        :class="imgClass"
        :medium-id="brand?.logo"
        :preset="logoPreset"
      />
      <NuxtImg
        v-else-if="brand?.logo && typeof brand?.logo == 'object' && props?.showLogo"
        densities="x1"
        :class="imgClass"
        provider="cloudflare"
        :src="'/' + brand?.logo?.originalData"
        :alt="brand?.logo?.name"
        :preset="logoPreset"
      />
      <template v-if="brand?.name && !props?.showLogo">{{ brand?.name }}</template>
    </div>
  </template>
  
</template>

<script setup lang="ts">
import { getExpBrand, getExpManufacturer } from "~/composables/ExpApi/expCache";

interface Props {
  brandId: string;
  imgClass?: string | null;
  showLogo?: boolean;
  isManufacturer?: boolean;
  logoPreset?: string | undefined;
  createLink?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  showLogo: false,
  imgClass: null,
  isManufacturer: false,
  logoPreset: undefined,
  createLink: false,
});

// if props.isManufacturer then getManufacturer else getBrand
const { data: brand } = props?.isManufacturer
    ? await getExpManufacturer(props?.brandId)
    : await getExpBrand(props?.brandId);
</script>
